import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { WorkloadEligibleAgentEntity } from '../../../domain/entities/workload-eligible-agent.entity';
import { TeamWorkloadRepository } from '../../../infrastructure/repositories/team-workload.repository';
import { GetWorkloadEligibleAgentsQuery } from './get-workload-eligible-agents.query';

@Injectable({ providedIn: 'root' })
export class GetWorkloadEligibleAgentsUseCase {
  private readonly _repository = inject(TeamWorkloadRepository);

  public execute(query: GetWorkloadEligibleAgentsQuery): Observable<WorkloadEligibleAgentEntity[]> {
    return this._repository.getEligibleAgents(query.investigationIds, query.search);
  }
}
